module.exports = __webpack_public_path__ + "static/media/yiyuan2.16049aca.png";